<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
     
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
     
      <div class="col-md-12">
      <div class="row">
        <!-- <form class="row" @submit.prevent="rechercher"> -->
          <!-- <div class="col">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
               Mot clé
              </label>
              <Field 
                style="max-height: 42px;"
                v-model="searchTerm"
                @keyup="rechercher" 
                name="mot" 
                type="text" 
                aria-disabled="true"
                class="form-control shadow-none fs-md-15 text-black" 
                placeholder="Recherche par mot clé"/>
            </div>
          </div> -->
          <div class="col">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
               Inventaire <span class="text-danger">*</span>
              </label>
              <Field v-model="_inventaire" name="inventaire" v-slot="{ field }">
                <Multiselect
                  :options="inventaireOptions" 
                  :searchable="true"
                  v-model="field.value"
                  v-bind="field"
                  placeholder="Sélectionner le inventaire"
                />
              </Field>
              <ErrorMessage name="inventaire" class="text-danger"/>
            </div>
          </div>
          <div class="col">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Produit <span class="text-danger">*</span>
              </label>
              <Field v-model="_produit"   name="produit" v-slot="{ field }">
                <Multiselect
                  :options="produitOptions" 
                  :searchable="true"
                  v-bind="field"
                  placeholder="Sélectionner un produit"
                />
              </Field>
              <ErrorMessage name="produit" class="text-danger"/>
            </div>
          </div>
      </div>
      </div>
      <hr>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Produit
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                Stock Log
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                Stock Fiche
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                Stock Ven
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                Qte Avariée
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                Ecarts réel
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                Ecarts Log
              </th>
              <th scope="col"  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >Observation</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(produitInventaire, index) in produitInventaires" :key="index">
              <td class="shadow-none lh-1 fw-medium">
                {{ produitInventaire.ref }} {{ produitInventaire.nomProd }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                {{ produitInventaire.qteLogique }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                {{ produitInventaire.qteFiche }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ produitInventaire.qtePhysique }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ produitInventaire.qteAvariee }}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ produitInventaire.ecartLogique}}
              </td>
              <td class="shadow-none lh-1 fw-medium ">
                {{ produitInventaire.ecartFiche }}
              </td>
              <td class="shadow-none lh-1 fw-medium " >
                {{ produitInventaire.observation }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>


</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from "@/services/ApiService";
import { useRouter } from 'vue-router';
import { format_date,suppression,format_Date,separateur } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Multiselect from '@vueform/multiselect';

export default defineComponent({
    name: "ListeProduitIventaire",
    components: {
      Field,
      Multiselect,
      PaginationComponent,
  },
  setup: () => {
    

    const produitInventaires = ref<Array<any>>([]);
    const produitInventaire = ref<any>();
    const produitOptions = ref([]);
    const inventaireOptions = ref([]);
    const inventaire = ref([]);
    const produit = ref([]);
    const selectedEtat = ref('');

    // BEGIN PAGINATE
    const _produit = ref('');
    const _inventaire = ref('');
    const inventaires = ref();
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const router = useRouter();

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllProduitInventaires(page_, limit_);
      } catch (error) {
        //
      }
    };
   
    watch(_produit, () => {
      rechercher();
    });

    
    watch(_inventaire, () => {
      rechercher();
    });

    function rechercher(){
      getAllProduitInventaires(page.value, limit.value, searchTerm.value, _inventaire.value, _produit.value );
    }


    const fetchProduits = async () => {
      ApiService.get("/all/produits")
      .then(({ data }) => {
        const donnees = data.data.data;
        produitOptions.value = donnees.map((produit) => {
          return {
            value: produit.id,
            label: produit.nomProd,
          }
        });
      })
      .catch(({ response }) => {
        // error(response.data.message)
      });
    }


    const fetchinventaires = async () => {
      ApiService.get("/inventaires/statut/3")
      .then(({ data }) => {
        const donnees = data.data;
        console.log(data,donnees,"44444444444444444444444444444444444444444444444")
        inventaireOptions.value = donnees.map((inventaire) => {
          return {
            value: inventaire.id,
            label: `${inventaire.refInventaire} [${format_date(inventaire.dateDebut)} - ${format_date(inventaire.dateFin)}]- ${inventaire.magasin.nomMagasin}`,
          }
        });
      })
      .catch(({ response }) => {
        // error(response.data.message)
      });
    }

    function getAllProduitInventaires(page = 1, limi = 10, searchTerm = '', _inventaire = '' , _produit = '') {
      return ApiService.get(`/produit/inventaire?page=${page}&limit=${limi}&mot=${searchTerm}&inventaire=${_inventaire}&produit=${_produit}&`)
        .then(({ data }) => {
          console.log(data,"datadatadatadatadata");
          produitInventaires.value = data.data.data
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
        })
        .catch(({ response }) => {
          // error(response.data.message);
        });
    }

    onMounted(() => {
      getAllProduitInventaires();
      fetchProduits();
      fetchinventaires();
    });

    

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }
    
    return { 
      produitInventaires,
      checkPermission,
      produitOptions,
      inventaireOptions,
      format_date,
      suppression,
      getAllProduitInventaires, 
      page, 
      totalPages,
      limit,
      format_Date,
      totalElements,
      handlePaginate,
      separateur,
      searchTerm,
      _inventaire,inventaires,
      _produit,inventaire,produit,
      rechercher,
      Multiselect,
      selectedEtat
    };
  },
});
</script>

